<template>
  <div class='v-dialog' :class='{active: show, [`v-dialog-${item.size}`]: item.size}'>
    <div 
      :style="{ 'z-index': (currentZIndex - 1)}"
      class="dimmed_black v-dialog-overlay" style="top:0;display:block;" @click='onMaskClose()'></div>
    
    <div 
      :style="{ 'z-index': (currentZIndex)}"
      class='rew19_popContainer small v-dialog-container'>
      <div class='rew19_popup_wrap v-dialog-header'>
        <h2>
          <span class="rew19_basketList_tit v-dialog-title" v-if='item.title'>{{ item.title }}</span>
          <button class="rew19_basketList_btn v-dialog-btn v-dialog-btn-close" @click='onClose()'><span>닫기</span></button>
        </h2>
      </div>
      <div class='rew19_popup_cont v-dialog-body'>
        <p v-html='item.message'></p>
      </div>    
      <div class='rew19_popup_btn rew19_clear v-dialog-footer'>
        <button class="rew19_popHarf disabled v-dialog-btn v-dialog-btn-danger" @click='onClose(false)' v-if='item.cancelLabel'>{{ item.cancelLabel }}</button>
        <button class="activation v-dialog-btn success" @click='onOk' 
          :class='{rew19_popHarf: item.cancelLabel, rew19_popFull: !item.cancelLabel}'>{{ item.okLabel }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    maskClick:{
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 1000
    },
  },  
  data() {
    return {
      currentZIndex : 1000
    }    
  },
  mounted() {
    let _this = this;

    _this.currentZIndex = _this.$getDimmMaxIndex() + 2;
  },
  methods: {

    onClose(response) {
      this.$emit('close', this.item, response)
    },

    onMaskClose(response){
      if(this.maskClick){
        this.onClose(response)
      }
    },
    
    onOk() {
      this.onClose(true)
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Dialog/Dialog.vue